export default __webpack_public_path__ + "static/media/tlou_split.c542ad4c.mp4";